<script setup>
import { computed } from "vue";
import { useSubtitlesStore } from "@/stores/subtitles";

const props = defineProps({
  id: String,
  image: String,
  name: String,
  language: {
    type: String,
    default: null,
  },
});

const imageUrl = computed(() => {
  return `${import.meta.env.VITE_S3_BASE_URL}${props.image}`;
});
</script>

<template>
  <div
    class="bg-[#f5f5f5] rounded-2xl p-[5px] mb-2 flex flex-row gap-3 items-center cursor-pointer w-full"
  >
    <img
      :alt="`channel ${name} flag`"
      :src="imageUrl"
      class="shrink-0 rounded-[10px] w-[75px] aspect-flag"
    />
    <p class="grow font-semibold text-xl max-w-fit truncate">
      {{ name }}
    </p>
    <font-awesome-icon
      v-if="useSubtitlesStore().getChannelIsActive(id)"
      icon="fa-solid fa-closed-captioning"
      size="lg"
      class="ml-auto mr-1"
    />
  </div>
</template>
